<template>
    <v-card outlined elevation="1" class="summary-card">
        <v-card-text class="text-center" py-6>
            <h5 class="text-h5 mb-3">{{ title }}</h5>
            <h6 v-if="showAmount" class="text-h6 primary--text">{{ amount }}</h6>
            <h6 v-else class="text-h6 hidden-amount primary--text">****</h6>
        </v-card-text>
    </v-card>
</template>

<script>
export default {
  name: 'cash-summary-card',
  props: {
    title: { type: String, required: true },
    amount: { type: String, required: true },
    showAmount: { type: Boolean, required: true },
  },
};
</script>

<style scoped>
.summary-card {
    border-radius: 10px;
}
.hidden-amount {
  font-size: 24pt !important;
}
</style>
